import React, { createContext, useContext, useState } from 'react';

const RouteIsLoadingContext = createContext();

export const useRouteIsLoading = () => useContext(RouteIsLoadingContext);

export const RouteIsLoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <RouteIsLoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </RouteIsLoadingContext.Provider>
  );
};
